import React, { useEffect, useState } from 'react';

export const STANDINGS_MAX_ROWS = 12;
function rowsForViewport(height) {
  // These are TV-friendly hard caps, not a scale-all-to-fit list.
  if (height <= 780) return 8;
  if (height <= 900) return 10;
  return STANDINGS_MAX_ROWS;
}

export default function PredictionStandings({ leaderboard = [] }) {
  const [cap, setCap] = useState(() => rowsForViewport(window.innerHeight));
  useEffect(() => {
    const resize = () => setCap(rowsForViewport(window.innerHeight));
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  // Do not modify the supplied ranking/order/tie semantics: rows and ranks are
  // preserved exactly in the order supplied by the existing leaderboard API.
  const visible = leaderboard.slice(0, cap);
  return (
    <section className="pw2-standings" aria-label="Prediction pool standings">
      <header className="pw2-section-header">
        <strong>Prediction Pool</strong>
        <span>{`TOP ${visible.length} OF ${leaderboard.length}`}</span>
      </header>
      <div className="pw2-standings-rows" style={{ '--pw2-standings-count': Math.max(visible.length, 1) }}>
        {visible.length ? visible.map((entry, i) => (
          <div key={`${entry.user_name}-${i}`} className={`pw2-standing ${i === 0 ? 'pw2-first' : ''}`}>
            <span className="pw2-standing-rank">{i + 1}</span>
            <span className="pw2-standing-name" title={entry.user_name}>{entry.user_name}</span>
            <span className="pw2-standing-score">{entry.score}<small>pts</small></span>
          </div>
        )) : <div className="pw2-empty">NO ENTRIES</div>}
      </div>
    </section>
  );
}
